import { createApp } from 'vue';
import CalculatorWidget from '@/CalculatorWidget.vue';
import 'focus-visible';
import '@/assets/scss/main.scss';

const calculatorWidget = createApp(CalculatorWidget);
calculatorWidget.mount('#calculator-widget');
